"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const osmHelpers_1 = require("../helpers/osmHelpers");
class PostAdded {
    constructor(container, addMarkersFromLocationInstance) {
        this.container = container;
        this.addMarkersFromLocationInstance = addMarkersFromLocationInstance;
        this.listenForPostAdded();
    }
    listenForPostAdded() {
        this.container.addEventListener('postAdded', (e) => {
            const customEvent = e;
            const locationElement = customEvent.detail.querySelector('[data-js-map-location]');
            if (locationElement) {
                const markerData = (0, osmHelpers_1.getMarkerDataFromElement)(locationElement);
                this.addMarkersFromLocationInstance.add(markerData);
            }
        });
    }
}
exports.default = PostAdded;
